import { Resource } from '../index'
import GroupWork from '@mui/icons-material/GroupWork'
import { PERMISSIONS } from '../../constants'
import list from './ChainList'
import create from './ChainCreate'
import edit from './ChainEdit'
import show from './ChainShow'

export default {
  edit,
  list,
  create,
  show,
  name: 'chains',
  permissions: [PERMISSIONS.ADMIN],
  options: { label: 'Rede' },
  icon: GroupWork,
} as Resource;
